const STORAGE_KEY = "ton_theme";

/** Aktuell aktives Farbschema ("light" oder "dark"), abgeleitet von der <html>-Klasse. */
export function getTheme() {
  if (typeof document === "undefined") return "light";
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

/** Setzt das Farbschema, schaltet die "dark"-Klasse auf <html> und merkt sich die Wahl. */
export function setTheme(theme) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch (e) {
    // localStorage kann in manchen Umgebungen (privater Modus etc.) fehlschlagen – ignorieren.
  }
}

/** Wechselt zwischen "light" und "dark" und gibt das neue Farbschema zurück. */
export function toggleTheme() {
  const next = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}
